import { render, staticRenderFns } from "./VendorPerorangan.vue?vue&type=template&id=43f38dde&"
import script from "./VendorPerorangan.vue?vue&type=script&lang=js&"
export * from "./VendorPerorangan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports